<!-- Sidenav -->
<div class="" (window:resize)="isMobile($event)">
  <app-navbar *ngIf="shouldShowNavbar()" [ngClass]="{ 'sidenav fixed-left': isMobileResolution === false }"></app-navbar>
  <div class="main-content">
    <router-outlet *ngIf="shouldRenderRouterOutlet()"></router-outlet>
    <app-loading *ngIf="shouldShowAuthTransitionLoading()" [show]="true"></app-loading>
  </div>
</div>
